import { fetchWrapper } from "../utils/fetch-wrapper";

const portefeuillesService = {
  getportefeuilleByID,
  getportefeuilleById_Client,
  post,
  getportefeuilleUuid,
  getAll,
  delete: _delete,
  update
};

function getportefeuilleUuid(uuid) {
  return fetchWrapper.get(`portefeuilles/uuid/${uuid}`);
}
function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");
  return fetchWrapper.get(`portefeuilles/?${queryString}`);
}

function post(data) {
  return fetchWrapper.post("portefeuilles/", data);
}

function getportefeuilleByID(id) {
  return fetchWrapper.get(`portefeuilles/${id}`);
}

function getportefeuilleById_Client(id) {
  return fetchWrapper.get(`portefeuilles/env_client/${id}`);
}

function _delete(id) {
  return fetchWrapper.delete(`portefeuilles/${id}`);
}

function update(id, params) {
  return fetchWrapper.put(`portefeuilles/${id}`, params);
}

export default portefeuillesService;
